import { Flex, TextInput } from "@mantine/core";
import { FormRow } from "../components/common/Form/FormRow";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useForm } from "@mantine/form";
import { validateRequired } from "../utils/validations";
import { createDepartment } from "../api/departmentApi";
import { creationNotification, errorNotification } from "../utils/useNotification";
import { unwrap } from "../utils/apiResult";
import { useAuth } from "../context/AuthContext";
import PlusIcon from "../components/common/Icons/PlusIcon";
import { useRef } from "react";

/**
 * YENİ DEPARTMAN.
 *
 * ⚠ Departman ÇALIŞMA DÜZENİ TAŞIMAZ (plan 2.35, 21 Ağu). Haftalık mesai
 * planı (`WeeklySchedule`), gün kesimi ve mesai önceliği alanları kaldırıldı;
 * kullanıcı kararı: "departmanlarda saat ayarlaması olmayacak, onu vardiya ile
 * sağlayacak." Vardiya tanımı departmanın `workHours`'ının daha zengin hâliydi
 * (tolerans alanları departmanda hiç yoktu) ve aynı kavram iki yerde
 * duruyordu.
 *
 * Çalışma düzeni artık: Vardiyalar → Vardiya Listesi (tanım) + Personel Atama
 * (kim, ne zaman) ya da Ekipler + Rotalar (dönüşümlü).
 */
const NewDepartment = () => {
  const { refetchDepartmentSelectData } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<any>({
    initialValues: { name: "", description: "" },
    validate: { name: validateRequired, description: validateRequired },
  });

  const handleSubmit = async (values: any) => {
    try {
      const result = unwrap(await createDepartment(values));

      if (result.ok) {
        creationNotification("Departman", true);
        refetchDepartmentSelectData();
        form.reset();
        return;
      }

      // Eskiden tarayıcı alert()'i vardı; panelin geri kalanıyla tutarlı olsun.
      errorNotification({ message: result.message ?? undefined });
    } catch (error) {
      console.error("Error:", error);
      errorNotification();
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Departman Kaydı"
        subText="Departman bir organizasyon birimidir; çalışma saatleri Vardiyalar bölümünden tanımlanır."
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
        <form
          ref={formRef}
          style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <FormRow $gap={12}>
            <TextInput
              label="Departman İsmi"
              placeholder="Departman İsmi Giriniz."
              radius={10}
              maxLength={40}
              size="md"
              {...form.getInputProps("name")}
            />
            <TextInput
              label="Departman Açıklaması"
              placeholder="Departman Açıklaması Giriniz."
              radius={10}
              maxLength={150}
              size="md"
              {...form.getInputProps("description")}
            />
          </FormRow>
        </form>
      </div>
    </Container>
  );
};

export default NewDepartment;
